import { FunctionComponent } from 'react';

import SectionResultBeforeAfter from 'components/modules/public/layout/sections/ResultBeforeAfter';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageBundleSectionBundleComparision: FunctionComponent<Props> = ({ comparisonsData }) => {
    if (comparisonsData?.length === 0) return null;

    return (
        <StyledComponent className="public-page-product-section-bundle-comparision">
            {comparisonsData?.map((comparison, index) => (
                <SectionResultBeforeAfter
                    key={`${comparison.imageBefore}-${index}`}
                    headline={comparison.headline}
                    subheadline={comparison.subheadline}
                    imageBefore={comparison.imageBefore}
                    imageAfter={comparison.imageAfter}
                    comparisonList={comparison.imagesBeforeAfterList}
                />
            ))}
        </StyledComponent>
    );
};

export default PublicPageBundleSectionBundleComparision;
